import React from 'react'
import { isNil } from 'lodash'
import { IconPlayerPause } from '@tabler/icons-react'

import { Banner } from '@/components/banners/Banner'

// What the cards and status of an org at its size limit say, so every place names it alike.
export const ORG_NEW_FILES_PAUSED_LABEL = 'New files paused'

// Every listed connection carries the same org usage; older agent-gpt sends none.
export const pausedOrgUsage = (connections) =>
  connections.map((connection) => connection.org_usage).find((usage) => usage?.paused) ?? null

export const orgNewFilesPaused = (connection) => connection.org_usage?.paused === true

// How full the org is, as a whole percent of its limit; over 100 once it is past it.
export const percentOfLimit = (usage) => Math.floor((usage.objects / usage.ceiling) * 100)

/**
 * Says why new documents aren't arriving when the org holds more of the shared index
 * than one org may (RTG3-1300). agent-gpt keeps applying changes and deletions but adds
 * no new files until the org drops below, so without this every connection would look
 * healthy while new documents quietly never appear.
 *
 * @param {Array} props.connections the listed connections, each carrying `org_usage`
 */
export const OrgSyncPausedBanner = ({ connections }) => {
  const usage = pausedOrgUsage(connections)
  if (isNil(usage)) {
    return null
  }
  return (
    <Banner
      warning
      icon={<IconPlayerPause />}
      className="mbs"
      data-testid="knowledge-base-org-paused"
    >
      <div className="flex-column small-gap">
        <strong>New documents aren’t being added for this organization</strong>
        <p>
          Its knowledge base is at {percentOfLimit(usage)}% of its size limit, so new documents
          won’t reach AI Answers until it’s back under. Changes and deletions to documents already
          there still sync. Size depends on how much content is indexed, not just how many files:
          large spreadsheets and long documents count for more.
        </p>
        <p>
          To make room, remove a site, library or drive below, or block files in Manage files; both
          take effect right away. Or contact Balto support.
        </p>
      </div>
    </Banner>
  )
}
